export default __webpack_public_path__ + "static/media/done2.088ba78e.svg";